import React from 'react';
import { Modal, Spinner } from './ui';
import { useReportShare } from './useReportShare';

// Phone Share / Export: big buttons, no side panel. The preview is a short
// strip (a PDF in a phone-sized frame is barely readable), and "Send to another
// app" hands the file to WhatsApp, Drive or mail through the OS sheet.
export default function ReportShareMobile(props) {
  const vm = useReportShare(props);
  const {
    kind, setKind, orientation, setOrientation, density, setDensity, busy, previewUrl, fileName,
    rowCount, columnCount, title, subtitle, save, print, shareFile, canShareFile, close,
  } = vm;

  return (
    <Modal
      fullScreen title={`Share / Export — ${title}`} onClose={close}
      footer={<>
        <button className="btn light" onClick={close}>Close</button>
        <button className="btn primary" style={{ flex: 1, padding: 12 }} data-save="primary"
          disabled={!!busy} onClick={() => (canShareFile ? shareFile() : save())}>
          {busy ? 'Working…' : canShareFile ? '↗ Share file' : '↓ Save file'}
        </button>
      </>}
    >
      <div className="step-label">Format</div>
      <div className="chips-row" style={{ marginBottom: 12 }}>
        {[['pdf', '📄 PDF'], ['excel', '📊 Excel']].map(([value, label]) => (
          <button key={value} type="button" className={'chip-toggle' + (kind === value ? ' on' : '')}
            onClick={() => setKind(value)}>{label}</button>
        ))}
      </div>

      {kind === 'pdf' && (
        <>
          <div className="step-label">Rows</div>
          <div className="chips-row" style={{ marginBottom: 12 }}>
            {[['compact', 'Compact'], ['normal', 'Bigger text']].map(([value, label]) => (
              <button key={value} type="button" className={'chip-toggle' + (density === value ? ' on' : '')}
                onClick={() => setDensity(value)}>{label}</button>
            ))}
          </div>
          <div className="step-label">Page</div>
          <div className="chips-row" style={{ marginBottom: 12 }}>
            {[['landscape', 'Landscape'], ['portrait', 'Portrait']].map(([value, label]) => (
              <button key={value} type="button" className={'chip-toggle' + (orientation === value ? ' on' : '')}
                onClick={() => setOrientation(value)}>{label}</button>
            ))}
          </div>
        </>
      )}

      <div className="muted" style={{ fontSize: 12.5, marginBottom: 10, lineHeight: 1.7 }}>
        {subtitle && <div>{subtitle}</div>}
        <div>{rowCount} {rowCount === 1 ? 'row' : 'rows'} · {columnCount} columns</div>
        <div style={{ wordBreak: 'break-all' }}>{fileName}</div>
      </div>

      {kind === 'pdf' && (
        busy === 'preview' || !previewUrl
          ? <div className="card card-pad" style={{ display: 'grid', placeItems: 'center', height: 180 }}><Spinner /></div>
          : <iframe title="Report preview" src={previewUrl} className="share-frame" style={{ height: 300 }} />
      )}

      <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
        <button className="btn light" style={{ padding: 12 }} disabled={!!busy} onClick={() => save('pdf')}>↓ Save PDF</button>
        <button className="btn light" style={{ padding: 12 }} disabled={!!busy} onClick={() => save('excel')}>↓ Save Excel</button>
        <button className="btn light" style={{ padding: 12 }} disabled={!!busy} onClick={print}>🖨 Print</button>
      </div>
    </Modal>
  );
}
